import { NgModule } from '@angular/core';
import { DebounceKeyUpDirective } from './debounce-keyup.directive';

@NgModule({
    declarations: [
        DebounceKeyUpDirective
    ],
    exports: [
        DebounceKeyUpDirective
    ]
})
export class DebounceKeyUpModule { }